import classNames from 'classnames';
import { Dropdown } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const RevealDropdownTrigger = ({ children, className, ...rest }) => {
  return (
    <div className={classNames('btn-reveal-trigger', className)} {...rest}>
      {children}
    </div>
  );
};

const RevealDropdown = ({
  children,
  className,
  btnClassName,
  dropdownMenuClassName,
  icon = 'ellipsis',
  align = 'end',
  popperConfig
}) => {
  return (
    <Dropdown className={classNames(className)} align={align}>
      <Dropdown.Toggle
        variant=""
        size="sm"
        className={classNames(
          btnClassName,
          'btn-reveal dropdown-caret-none transition-none'
        )}
      >
        <FontAwesomeIcon icon={icon} className="fs-10" />
      </Dropdown.Toggle>
      {/* renderOnMount + popperConfig let callers float the menu (strategy:'fixed')
          so it isn't clipped by / doesn't add a scrollbar to a short overflow table */}
      <Dropdown.Menu
        align={align}
        renderOnMount
        popperConfig={popperConfig}
        className={classNames(dropdownMenuClassName, 'py-2')}
      >
        {children}
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default RevealDropdown;
